import axios from "axios";

const WIZ_ME_BFF_URL = process.env.REACT_APP_SELF_LEARNING_BFF_URL;

/**
 * Retrieves the student's Wizme ID using the IES access_token.
 *
 * @param {string} accessToken - The access_token returned by iesLogin.
 * @returns {Promise<string|null>} The student's Wizme ID (platformId), or null on failure.
 */
export async function getWizmeIdFromIESCode(accessToken) {
  if (!WIZ_ME_BFF_URL) {
    console.error("[WizmeBFF] REACT_APP_SELF_LEARNING_BFF_URL not set.");
    return null;
  }

  try {
    const response = await axios.post(
      `${WIZ_ME_BFF_URL}/wizme/user`,
      {
        accessToken,
      },
      {
        headers: {
          "x-api-key": process.env.REACT_APP_SELF_LEARNING_BFF_URL_API_KEY,
        },
      },
    );

    const payload = (response.data && response.data.data) || response.data;
    const wizmeId = (payload && payload.id) || null;

    return wizmeId;
  } catch (error) {
    console.warn(
      "[WizmeBFF] Could not retrieve Wizme user:",
      (error && error.response && error.response.data) || error.message,
    );
    return null;
  }
}
